module.exports = __webpack_public_path__ + "img/regulation-4.e64890ad.svg";